import {Box, Skeleton} from '@mui/material'
import type {FC, ReactElement} from 'react'
import BasicDashboardContainer from '@shared/components/BasicDashboardContainer'

const TasksLoader: FC = (): ReactElement => (
  <BasicDashboardContainer>
    <Box data-testid="mbai-main-tasks-page-loader" sx={{width: '100%', height: '100vh'}}>
      {/* Worklist tabs */}
      <Box sx={{display: 'flex', gap: 3}}>
        <Skeleton variant="text" sx={{width: 110}} />
        <Skeleton variant="text" sx={{width: 80}} />
        <Skeleton variant="text" sx={{width: 50}} />
      </Box>
      {/* The one filter row inside the grid header, plus the primary action */}
      <Box sx={{mt: 2, display: 'flex', alignItems: 'center', gap: 0.75}}>
        <Skeleton variant="rounded" sx={{width: 170, height: 31}} />
        <Skeleton variant="rounded" sx={{width: 150, height: 31}} />
        <Skeleton variant="rounded" sx={{width: 165, height: 31}} />
        <Skeleton variant="rounded" sx={{width: 150, height: 31}} />
        <Skeleton variant="rounded" sx={{width: 250, height: 31}} />
        <Skeleton variant="rounded" sx={{width: 148, height: 31, ml: 'auto'}} />
      </Box>
      <Box sx={{mt: 2}}>
        <Skeleton variant="rounded" sx={{width: '100%', height: 'calc(100vh - 200px)'}} />
      </Box>
    </Box>
  </BasicDashboardContainer>
)

export default TasksLoader
